module.exports = __webpack_public_path__ + "static/media/myservices_popup_phone.50df0e45.svg";